import { CssBaseline, ThemeProvider } from "@mui/material"
import { ReactKeycloakProvider } from "@react-keycloak/web"
import React, { useEffect } from "react"
import Helmet from "react-helmet"
import { useDispatch, useSelector } from "react-redux"
import { Route, Routes, useLocation } from "react-router-dom"
import Header from "../components/Common/Header"
import LoadingCircle from "../components/Common/Loading"
import config from "../config"
import { MenuProvider } from "../core/context/menuContext"
import { store } from "../core/utils/configureStore"
import { keycloak } from "../keycloak-config"
import "./App.css"
import { SnackBarProvider } from "../snackBarProvider"
import theme from "../theme"
import GameActions from "./GameActions"
import GamesList from "./GamesList"
import Login from "./Login"
import ZendeskTransfer from "./ZendeskTransfer"
import ZendeskAuthHint from "./ZendeskTransfer/AuthHint"

export function App() {
    const dispatch = useDispatch()

    const UserSession = useSelector((state) => state.data.UserSession)
    // Compact pages embedded into the Zendesk sidebar - no Hermes header/nav.
    const isZendeskEmbed = useLocation().pathname.startsWith("/zendesk")

    useEffect(() => {
        if (window.localStorage.getItem("isProd") === null) {
            switch (document.location.host) {
                case "hermes2.belka-games.com": {
                    dispatch({ type: "MODE_PROD" })
                    window.localStorage.setItem("isProd", "true")
                    break
                }
                case "hermes2.stage.belka-games.com": {
                    dispatch({ type: "MODE_STAGING" })
                    window.localStorage.setItem("isProd", "false")
                    break
                }
                case "localhost:3000": {
                    dispatch({ type: "MODE_STAGING" })
                    window.localStorage.setItem("isProd", "false")
                    break
                }
            }
        }
    }, [dispatch])

    function kcEvent(event) {
        if (event == "onAuthLogout") {
            keycloak.logout()
        }

        if (event == "onAuthRefreshSuccess") {
            sessionStorage.setItem("kctoken", keycloak.token)
        }

        if (event == "onAuthSuccess") {
            if (keycloak.authenticated) {
                sessionStorage.setItem("kctoken", keycloak.token)

                let isAdmin = false
                if (keycloak.realmAccess.roles.includes("BELCOINSHOP_ADMIN")) {
                    isAdmin = true
                }

                store.dispatch({
                    type: "AUTH_SELF_SUCCESS", payload: {
                        data: {
                            username: keycloak.idTokenParsed.name ? keycloak.idTokenParsed.name : keycloak.idTokenParsed.preferred_username,
                            isAdmin: isAdmin,
                            roles: keycloak.realmAccess.roles
                        }
                    }
                })
            } else {
                store.dispatch({ type: "AUTH_LOGOUT" })
            }
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <MenuProvider>
            <CssBaseline/>
            <Helmet {...config.app}></Helmet>
            {!isZendeskEmbed && <Header />}
            <ReactKeycloakProvider
                LoadingComponent={<LoadingCircle />}
                onEvent={kcEvent}
                initOptions={{ onLoad: "check-sso", checkLoginIframeInterval: 1000 }}
                authClient={keycloak}
            >
                <SnackBarProvider>
                    {
                        UserSession.authenticated === true
                            ? (
                                <Routes>
                                    <Route path="" element={<GamesList />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/zendesk/transfer/:game" element={<ZendeskTransfer />} />
                                    <Route path="/:game" element={<GameActions />}>
                                        <Route index />
                                        <Route path=":action" />
                                        <Route path=":action/:deviceId" />
                                        <Route path=":action/:deviceId/:tab" />
                                        <Route path=":action/:deviceId/:tab/:subtab" />
                                    </Route>
                                </Routes>
                            )
                            : (
                                isZendeskEmbed ? <ZendeskAuthHint /> : <Login />
                            )
                    }
                </SnackBarProvider>
            </ReactKeycloakProvider>
            </MenuProvider>
        </ThemeProvider>
    )
}
